import React, { useEffect, useState } from "react";
import { Button, IconButton } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { red } from '@mui/material/colors';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import ModeEditOutlineRoundedIcon from '@mui/icons-material/ModeEditOutlineRounded';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import Modal from "@mui/material/Modal";
import "../Dashboard.css";
import "../Components/SideMenu.css";
import SideMenu from "../Components/SideMenu";
import "mdb-ui-kit/css/mdb.min.css";
import AddBranchForm from "./AddBranchForm";

import CircularIndeterminate from '../../GeneralComponents/CirularProgress'
import StyledDataGrid from '../../GeneralComponents/StyledDataGrid'
import "../../../../assets/css/DG.css"
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import AddIcon from '@mui/icons-material/Add';
import { useGlobalContext } from '../../../../context'
import UpdateBranchForm from "./Branches/UpdateBranchForm";
import ViewBranch from "./Branches/ViewBranch";
import axios from "axios";
import ApiSettings from "../../../../Settings/ApiSettings.json";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import BranchRoleForm from "./Branches/BranchRoleForm";
import swal from 'sweetalert'
import LinearProgress from '@mui/material/LinearProgress';
import UserBranchRoleForm from "./UserBranchRoles/UserBranchRoleForm";
import { set } from "date-fns";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
};

export default function AddUserBranchRole(props) {

  const [userBranchList, setUserBranchList] = useState([])

  const [pageSize, setPageSize] = useState(5);
  const [pageNumber, setpageNumber] = useState(1);
  const [branchesListTotal, setBranchesTotal] = useState(0)
  const [branchesListNumberOfPages, setBranchesNumberOfPages] = useState(0)
  const [showBoxOfAddForm, setShowBoxOfAddForm] = useState(false)
  const [selectedObject, setSelectedObject] = useState(null);
  const { loading, branchesList, fetchData } = useGlobalContext()
  const [reload, setReload] = useState(false)

  const [rows, setRows] = useState([])
  const columns = [
    { field: 'id', headerName: 'ت', flex: .1 },

    { field: 'branch_name', headerName: 'اسم الفرع', flex: 0.5 },
    { field: 'role_name', headerName: 'المسمى الوظيفي', flex: 0.5 },

    {
      field: 'actions', flex: 0.5,
      headerName: 'الادوات',
      renderCell: (params) => (
        <strong>


          <IconButton
            style={{ marginLeft: 20 }}
            aria-label="مسح"
            size="small"
            onClick={() => {

              softDelete(params.row)
            }}
          >
            <Tooltip title="Delete">
              <DeleteRoundedIcon sx={{ color: red[500] }} />
            </Tooltip>
          </IconButton>
        </strong>
      ),
    },
  ];


  const handlePageChange = (newPage) => {
    setpageNumber(newPage + 1)
  }
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });

  const addObject = async () => {
    // setSelectedObject(object)
    setShowBoxOfAddForm(true)
  };


  const loadDataList = () => {

    fetchData('BRANCH_LIST', 'branches_list', {});
  }
  useEffect(() => {

    loadDataList()


  }, [pageSize, pageNumber, reload])

  useEffect(() => {
    console.log("props.branch_role");
    console.log(props?.object?.branch_role);
    if (props?.object?.branch_role && props?.object?.branch_role?.length > 0) {

      const branchRoleitems = props?.object?.branch_role?.map((branchRoleItem) => {
        return {
          id: branchRoleItem?.id,
          branch_name: branchRoleItem?.branch?.name,
          role_name: branchRoleItem?.role?.name

        }
      })
      console.log(branchRoleitems);
      setRows(branchRoleitems);
      setBranchesTotal(branchRoleitems.total)
      setBranchesNumberOfPages(branchRoleitems.last_page)
    }
  }, [props?.object?.branch_role])
  //Reformatting branchesList object once branchesList are loaded
  useEffect(() => {


    if (branchesList && branchesList.length > 0) {

      const reformatData = branchesList.map((rowBranch) => {


        var modifiedBranchRoles = rowBranch?.roles?.map((branchRole) => {

          var modifiedBranchRole = {
            ...branchRole,
            checked: false
          }

          if (props?.object?.branch_role && props?.object?.branch_role?.length > 0) {


            props?.object?.branch_role?.map((branchRoleItem) => {
              if (branchRoleItem?.id === branchRole?.pivot?.id) {

                modifiedBranchRole = {
                  ...modifiedBranchRole,
                  checked: true
                }
              }
            })
          }

          return modifiedBranchRole
        })


        return {
          ...rowBranch,
          roles: modifiedBranchRoles
        }


      })
      console.log(reformatData);
      setUserBranchList(reformatData)
    }
  }, [branchesList])

  const sentFormData = async () => {

    // console.log("branchRolesSelected",branchRolesSelected);
    // return ;
    // setLoading(true);

    let data = null;
    try {

      data = await axios({
        method: "put",
        url: ApiSettings.apiUrl + "/users/branch_roles/" + props?.object?.id,
        data: {
          branch_roles: rows.map(row => row?.id)
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization": 'ar'
        },
      });

      console.log("update", data);
      if (data) {
        if (data.data.status == 200) {
          // setLoading(false);

          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          // props.setReloadData()
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        // setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      // setLoading(false);
    }
  };

  //here we will sent request with data to save it in our database.
  const softDelete = async (object) => {

    // setLoading(true);
    swal({
      title: "هل انت متأكد?",
      text: "بمجرد حذفك للعنصر لن يكون بامكانك استاعدته!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          setRows(rows?.filter(row => row?.id != object?.id))
        }
      })
  };


  return (
    <div className="Dashboard_MOF px-0 mx-0">

      <div className="container-fluid h-100 w-100 mx-0 px-0">
        <div className="row rowContainer mx-0">
          <div className="col-md-12 col-xl-12 height-100 w-100 d-flex flex-column justify-content-center align-items-end  paddingForm">
            <IconButton
              style={{ marginLeft: 15, backgroundColor: '#5f7b8a' }}
              aria-label="عرض"
              size="small"
              onClick={() => {
                addObject()
              }}
            >
              <Tooltip title="اضافة مستخدم جديد">

                <AddIcon sx={{ color: '#FFFFFF' }} />
              </Tooltip>
            </IconButton>
            <div
              className={`FormContainer  `}
              style={{ height: 'calc(100% - 9em)', width: '95%', borderRadius: 10 }}>


              <StyledDataGrid
                rows={rows}
                columns={columns}
                rowCount={branchesList?.total ? branchesList?.total : 0}
                pageSize={pageSize}
                page={pageNumber - 1}
                onPageSizeChange={(newPageSize) => {
                  setPageSize(newPageSize)
                }}
                loading={loading}

                components={{
                  Footer: () => null,
                  LoadingOverlay: LinearProgress,
                }}
                rowsPerPageOptions={[5, 10, 20]}
                // pagination
                paginationMode="server"
                onPageChange={(params) => {
                  handlePageChange(params)
                }}
              />

              <Box width="45%" m="auto" sx={{ direction: 'ltr' }}>
                <Pagination
                  color="primary"
                  size="large"
                  count={branchesListNumberOfPages}
                  page={pageNumber}
                  showFirstButton
                  showLastButton
                  onChange={(e, p) => {
                    setpageNumber(p)
                  }}
                />
              </Box>


            </div>
            <Button sx={{
              width: '95%',
              backgroundColor: '#5f7b8a',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#5f7b8aaa',
                color: '#FFFFFF',
              }
            }} onClick={() => { sentFormData() }} >
              حفظ الكل
            </Button>
          </div>


        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={() => { setsnackBar({ ...snackBar, open: false }) }}
        anchorOrigin={{ vertical: snackBar.vertical, horizontal: snackBar.horizontal }}
      >
        <Alert
          onClose={() => { setsnackBar({ ...snackBar, open: false }) }}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>

      <Modal
        keepMounted
        open={showBoxOfAddForm}
        onClose={() => {

          setShowBoxOfAddForm(false);
        }}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box
          sx={style}
          style={{
            border: "none",
            outline: "none",
            borderRadius: "10px",
            overflow: "scroll",
          }}
          className="modalCroupsCarrier"
        >
          {showBoxOfAddForm &&
            <UserBranchRoleForm rows={rows} setRows={(rows) => { setRows(rows) }} userBranchList={userBranchList} setOpen={setShowBoxOfAddForm} />}
        </Box>
      </Modal>
      
    </div>
  );
}
